import { css } from '@emotion/css';
import { MONO_FONT_FAMILY } from '@medcom/shared-ui/styles/globalCss.ts';
import { theme } from 'antd';
import { useMemo } from 'react';

export const useLabResultOrderCellStyles = () => {
  const { token } = theme.useToken();
  return useMemo(
    () => ({
      date: css`
        color: ${token.colorTextSecondary};
        font-weight: bold;
        font-variant-numeric: tabular-nums;
      `,
      time: css`
        color: ${token.colorTextSecondary};
        font-size: small;
        font-variant-numeric: tabular-nums;
      `,
      orderNumber: css`
        color: ${token.colorTextTertiary};
        font-size: small;
        font-family: ${MONO_FONT_FAMILY};
      `,
    }),
    [token]
  );
};
